import { render } from "./HeroTopHeader.vue?vue&type=template&id=472998f3&scoped=true"
import script from "./HeroTopHeader.vue?vue&type=script&lang=js"
export * from "./HeroTopHeader.vue?vue&type=script&lang=js"

import "./HeroTopHeader.vue?vue&type=style&index=0&id=472998f3&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-472998f3"]])

export default __exports__